import { render, staticRenderFns } from "./MakeOrder.vue?vue&type=template&id=a18ff688&"
import script from "./MakeOrder.vue?vue&type=script&lang=js&"
export * from "./MakeOrder.vue?vue&type=script&lang=js&"
import style0 from "./MakeOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports